module.exports = __webpack_public_path__ + "img/Belarus.9d7bf4ac.gif";